module.exports = __webpack_public_path__ + "img/recursos.48a2d8ee.svg";